module.exports = __webpack_public_path__ + "img/TRANSITIONS-SIGNATURE-4.8bd0f32c.gif";